/* 页面底部footer组件 */
<template>
  <div class="foot">
    <div class="foot-container">
      <Row type='flex' justify="space-between" style="width:100%">
        <div class="foot-item">
          <div class="title">设计师工具</div>
          <ul class="list">
            <li><a :href="`${BASIC_URL.baseNuxt}${urlData.case}`" target="_blank">案例</a></li>
            <li><a :href="`${BASIC_URL.baseNuxt}${urlData.inspiration}`" target="_blank">素材库</a></li>
            <li><a :href="`${BASIC_URL.baseNuxt}${urlData.so}`" target="_blank">聚合搜图</a></li>
            <li><a :href="`${BASIC_URL.baseNext}${urlData.design}`" >方案设计</a></li>
            <li><a :href="`${BASIC_URL.baseNuxt}${urlData.collect}`" target="_blank">采集工具</a></li>
          </ul>
        </div>
        <div class="foot-item">
          <div class="title">云定制</div>
          <ul class="list">
            <li><a :href="`${BASIC_URL.baseNext}/smart`" target="_blank">智能报价</a></li>
            <li><a :href="`${BASIC_URL.baseNuxt}${urlData.cooperate}`" target="_blank">商务合作</a></li>
            <li><a :href="`${BASIC_URL.baseNext}${urlData.work}`" target="_blank">工作职位</a></li>
            <li><a :href="`${BASIC_URL.baseNuxt}${urlData.download}`">下载APP</a></li>
          </ul>
        </div>
        <div class="foot-item">
          <div class="title">探索住逻辑</div>
          <ul class="list">
            <li><a href="https://www.zhulogic.com/" target="_blank">住逻辑官网</a></li>
            <li><a :href="`${BASIC_URL.baseNuxt}`" target="_blank">云定制</a></li>
            <li><a href="https://www.belanim.com/" target="_blank">斑斓智造</a></li>
           </ul>
        </div>
        <div class="foot-item">
          <div class="title">帮助与支持</div>
          <ul class="list">
            <li><a :href="`${BASIC_URL.baseOld}/help/questionTypeDetail/1`" target="_blank">帮助中心</a></li>
            <li><a href="javascript:;" id="udeskIdContart" >在线客服</a></li>
            <li>联系我们
              <div class="tel">400-998-0137</div>
              <div class="time">9:00-18:00</div>
            </li>
          </ul>
        </div>
        <div><img src="https://oss.zhulogic.com/operation_picture/companyIcon.png" alt="" class="m-l-20" width="120px"></div>
      </Row>
      
      <div class="foot-bottom align-center">
        <p>Copyright © 2018 Zhulogic.com Inc.All Rights Reserved.
          <a href="http://beian.miit.gov.cn" target="_balnk">
            版权所有沪ICP备15042685号
          </a>
        </p>
      </div>
      <contact-box ref="contactBox"></contact-box>
    </div>
  </div>
</template>

<script>
import contactBox from "../contact-box/contact-box";
import { urlData } from "../../constants/header-nav.js";

export default {
  name: "ZFooter",
  props: {
    BASIC_URL: {
      type: Object,
      default: function() {
        return {};
      }
    },
    udesk: {
        type: Boolean,
        default:true,
    }
  },
  data(){
    return {
      urlData:urlData
    }
  },
  components: { contactBox },
  methods: {
    handleContart() {
      this.$refs.contactBox.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.inline-block{
  display: inline-block;
}
.align-left{
  text-align: left;
}
a{
  color: #fff;
  opacity: 1;
  transition: all 0.3s;
  &:hover{
    opacity: .8;
  }
}
.foot{
  background-color: #313131;
  padding-top: 91px;
  .foot-container{
    margin: 0 auto;
    width: 1200px;
    .foot-item{
      width:120px;
      height: 282px;
      color: #fff;
      line-height: 1;
      .title{
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 2px;
      }
      .list{
        margin-top: 30px;
        li{
          color: #fff;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 16px;
        }
        li ~ li{
          margin-top: 16px;
        }
      }
      .tel{
        font-size: 14px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 16px;
        letter-spacing: 1px;
        margin-top: 8px;
      }
      .time{
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 12px;
        letter-spacing: 1px;
        margin-top: 8px;
      }
    }
    .foot-bottom{
      padding-bottom:20px ;
      p{
        line-height:20px;
        color:#fff;
        font-size: 12px;
      }
    }
  }
}
</style>
